module.exports = __webpack_public_path__ + "img/project_1.1a67d52e.jpg";